<template>
  <!-- 官网后台 -->
  <div class="index_gw">
    <el-container>
      <el-header>
        <div class="header"></div>
      </el-header>
      <el-container>
        <el-aside width="12.5rem">
          <div class="aside">
            <el-row class="tac">
              <el-col>
                <el-menu
                  background-color="rgb(33, 48, 89)"
                  text-color="#fff"
                  active-text-color="#ffd04b"
                  router
                >
                  <el-submenu index="1">
                    <template slot="title">
                      <i class="el-icon-help"></i>
                      <span>网站后台</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item index="guanwang">监管系统官网</el-menu-item>
                      <el-menu-item index="guanwang2"
                        >课后服务官网</el-menu-item
                      >
                      <el-menu-item index="guanwang3">汇合官网</el-menu-item>
                      <el-menu-item index="guanwang4">教付保官网</el-menu-item>
                       <!-- <el-menu-item index="guanwang5">汇合网</el-menu-item> -->
                       <el-menu-item index="guanwang6">海马运动官网</el-menu-item>
                       <!-- <el-menu-item index="coach">海马运动教练局</el-menu-item> -->

                    </el-menu-item-group>
                  </el-submenu>
                  
                  <el-submenu index="2">
                    <template slot="title">
                      <i class="el-icon-help"></i>
                      <span>权限管理</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item index="root">账号管理</el-menu-item>
                      <el-menu-item index="role">角色管理</el-menu-item>
                      <el-menu-item index="power">权限树</el-menu-item>
                      <el-menu-item index="htmlRoot">资料转发权限</el-menu-item>
                      <el-menu-item index="deathList">分享管理</el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="3">
                    <template slot="title">
                      <i class="el-icon-help"></i>
                      <span>工作台</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item index="" key="http://www.baidu.com">
                        <a href="http://www.baidu.com" target="_self"
                          >机构监管后台</a
                        >
                      </el-menu-item>
                      <el-menu-item index="" key="aa">
                        <a href="" target="_self">机构管理后台</a>
                      </el-menu-item>
                      <el-menu-item index="" key="ss">
                        <a href="" target="_self">课后服务后台</a>
                      </el-menu-item>
                      <el-menu-item index="" key="xxx">
                        <a href="" target="_self">共享店铺后台</a>
                      </el-menu-item>
                      <el-menu-item index="" key="https://www.edupay.site/#/">
                        <a href="https://www.edupay.site/#/" target="_self"
                          >教付保后台</a
                        >
                      </el-menu-item>
                      <el-menu-item index="" key="https://www.wjcs.site/#/">
                        <a href="https://www.wjcs.site/#/" target="_self"
                          >外教超市后台</a
                        >
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                </el-menu>
              </el-col>
            </el-row>
          </div>
        </el-aside>
        <el-main>
          <div class="main">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {
    };
  },
  mounted: function () {},
  methods: {},
};
</script>
<style scoped>
.el-header {
  padding: 0;
}
a {
  color: #fff;
  text-decoration: none;
}
.header {
  height: 3.75rem;
  background-color: rgb(33, 48, 89);
}
.aside {
  margin-top: 1.25rem;
  height: 100vh;
  background-color: rgb(33, 48, 89);
}
.el-submenu .el-menu-item {
  min-width: 6.25rem
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue